import { HIDDENENDPOINTS_CUSTOMEREMAIL_LOAD, HIDDENENDPOINTS_CUSTOMEREMAIL_SET } from '../actionDefinitions';
import { fetchCustomerEmails_, setCustomerEmails_ } from './hiddenEndpointsApi';

export function fetchCustomerEmails() {
    return dispatch => {
        return fetchCustomerEmails_()
            .then(payload => {
                dispatch({
                    type: HIDDENENDPOINTS_CUSTOMEREMAIL_LOAD,
                    payload: payload
                });
            })
            .catch(payload => dispatch({ type: HIDDENENDPOINTS_CUSTOMEREMAIL_LOAD, error: true, payload }));
    };
}

export function setCustomerEmails(emails) {
    return dispatch => {
        return setCustomerEmails_(emails)
            .then(payload => {
                dispatch({
                    type: HIDDENENDPOINTS_CUSTOMEREMAIL_LOAD,
                    payload: payload
                });
            })
            .catch(payload => dispatch({ type: HIDDENENDPOINTS_CUSTOMEREMAIL_SET, error: true, payload }));
    };
}
